import React from 'react';

export default function SectionTitle({ eyebrow, title, subtitle, align = 'center', script }) {
  const alignCls = align === 'left' ? 'items-start text-left' : 'items-center text-center';
  return (
    <div className={`flex flex-col ${alignCls} gap-3 max-w-3xl ${align === 'center' ? 'mx-auto' : ''}`}>
      {eyebrow && (
        <div className="gd-divider">
          <span className="gd-eyebrow">{eyebrow}</span>
        </div>
      )}
      {script && (
        <div className="font-script text-[#c9a063] text-4xl md:text-5xl leading-none">{script}</div>
      )}
      <h2 className="font-serif-display text-3xl md:text-5xl text-white leading-tight">{title}</h2>
      {subtitle && <p className="text-white/65 text-lg leading-relaxed">{subtitle}</p>}
    </div>
  );
}
